import React from 'react';
import classNames from 'classnames';

import EditingContext from 'store/editingContext';
import Accordion from 'ui/accordion';

export default React.forwardRef(function EquipmentSection({ id, title, children, initialState=false }, ref) {
  const [expanded, setExpanded] = EditingContext.useState(id, initialState);
  const onToggle = React.useCallback(() => setExpanded(state => !state), [setExpanded]);

  return (
    <div className={classNames("d3p-Section", {"d3p-expanded": expanded})} ref={ref}>
      <h3 onClick={onToggle}>
        {title}
      </h3>
      <Accordion visible={expanded}>
        {children}
      </Accordion>
    </div>
  );
});
